import React from 'react';
import PropTypes from 'prop-types';
import { formatPercent } from './qualitySummaryHelpers';

export default function QualitySummaryCard({ label, stats, rftPercent }) {
  const rftClass = rftPercent != null && rftPercent < 90 ? 'is-low' : '';

  return (
    <div className="quality-summary-card" style={{ borderRadius: 10, padding: 14 }}>
      <div className="quality-summary-card-title" style={{ fontSize: 13, fontWeight: 700, marginBottom: 10 }}>
        {label}
      </div>

      <div style={{ display: 'flex', gap: 10 }}>
        {stats.map(s => (
          <div key={s.label} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <span className="quality-summary-stat-value" style={{ fontSize: 20, fontWeight: 700 }}>
              {s.value}
            </span>
            <span className="quality-summary-stat-label" style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.05em', marginTop: 2, textAlign: 'center' }}>
              {s.label}
            </span>
          </div>
        ))}
      </div>

      <div
        className="quality-summary-card-rft"
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 12, paddingTop: 10 }}
      >
        <span className="quality-summary-card-rft-label" style={{ fontSize: 11, fontWeight: 600 }}>
          Right First Time
        </span>
        <span className={`quality-summary-card-rft-value ${rftClass}`} style={{ fontSize: 16, fontWeight: 800 }}>
          {formatPercent(rftPercent)}
        </span>
      </div>
    </div>
  );
}

QualitySummaryCard.propTypes = {
  label: PropTypes.string.isRequired,
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    })
  ).isRequired,
  rftPercent: PropTypes.number
};

QualitySummaryCard.defaultProps = {
  rftPercent: null
};
